const SETTING_REVENUE_ADDRESS_LOADING = 'SETTING_REVENUE_ADDRESS_LOADING';
const SETTING_REVENUE_ADDRESS_SUCCESS = 'SETTING_REVENUE_ADDRESS_SUCCESS';
const SETTING_REVENUE_ADDRESS_FAILURE = 'SETTING_REVENUE_ADDRESS_FAILURE';

export const settingRevenueAddressActions = {
  SETTING_REVENUE_ADDRESS_LOADING,
  SETTING_REVENUE_ADDRESS_SUCCESS,
  SETTING_REVENUE_ADDRESS_FAILURE,
};
